import { Box, Flex, Text } from "@chakra-ui/react";

interface MethodTabProps {
    icon: React.ReactNode;
    label: string;
    description: string;
    colors: {
        border: string;
        bg: string;
        iconBg: string;
        textLabel: string;
        textDesc: string
    }
    onClick: () => void;
}

export function MethodTab({ icon, label, description, colors, onClick }: MethodTabProps) {
    return (
        <Box
            flex={1}
            borderRadius="12px"
            border="2px solid"
            borderColor={colors.border}
            bg={colors.bg}
            p={4}
            cursor="pointer"
            transition="all 0.2s"
            onClick={onClick}
        >
            <Flex align="center" gap={3}>
                <Box color={colors.iconBg} flexShrink={0}>
                    {icon}
                </Box>
                <Box>
                    <Text fontSize="sm" fontWeight="600" color={colors.textLabel}>{label}</Text>
                    <Text fontSize="xs" color={colors.textDesc}>{description}</Text>
                </Box>
            </Flex>
        </Box>
    );
}
